import { localStorageService } from "@Engage.Data/services/storage/localStorage/LocalStorageService";
import { StorageKeys } from "@Engage.Data/constants/Constants";
import { ActionRepository } from "../repositories/ActionRepository";
export class RegistrationWallService {
    static handleFirstLogin() {
        if (localStorageService.get(StorageKeys.SetRegWallCookie)) {
            localStorageService.delete(StorageKeys.SetRegWallCookie);
            ActionRepository.setPossibilityPresentForUser(true);
        }
    }
}
